import {Link} from "react-router-dom";

export const Home = () => {
  return (<>
  	<div className={`d-flex w100p h100vh justify-content-center align-items-center font-size-1_4em`}>
		  <Link to="/bachelor-thesis">Bachelor's thesis</Link>
	  </div>
  </>)
}